import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageHeading from '../components/PageHeading';
import VerticalSpacer from '../../components_common/VerticalSpacer/VerticalSpacer';
import QuoteText from '../../components_common/Press/QuoteText';
import PressArticles from '../../components_common/Press/PressArticles';
import PressImages from '../../components_common/Press/PressImages';
import PressOpportunitiesHeader from '../../components_common/Press/PressOpportunitiesHeader';
import SolidLineHeader from '../../components_common/Press/SolidLineHeader';

const mapStateToProps = state => ({
  s3BasePath: state.api.s3BasePath
});

const PressComponent = ({ s3BasePath }) => (
  <div>
    <PageHeading text="PRESS" />
    <VerticalSpacer height="20px" />
    <PressOpportunitiesHeader />
    <VerticalSpacer height="20px" />
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <img src={`${s3BasePath}press/press_page_mobile.jpg`} />
    </div>
    <VerticalSpacer height="40px" />
    <QuoteText />
    <VerticalSpacer height="35px" />
    <PressImages s3BasePath={s3BasePath} />
    <VerticalSpacer height="50px" />
    <SolidLineHeader />
    <VerticalSpacer height="30px" />
    <PressArticles />
  </div>
);

PressComponent.propTypes = {
  s3BasePath: PropTypes.string.isRequired
};

const Press = connect(mapStateToProps)(PressComponent);
export default Press;
